import * as types from './types'

export default {
  [types.SET_TRANSLATED_CALIBRATION_WELCOME_MESSAGE](state, data) {
    state.translatedCalibrationHomepageMessage = data
  }
}
